import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
// import WebViewer from '@pdftron/webviewer';
import { VisaDesignerService } from '../visa-designer.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { EncryptService } from '../../core/http/http-encrypt.service';
import { environment } from 'environment-configurations';

@Component({
  selector: 'app-form-mapping-component',
  templateUrl: './vd-builder-form-mapping.html',
  styleUrls: ['../visa-designer.scss','./vd-builder-form-mapping.scss'],
})
export class VdBuilderFormMappingComponent implements AfterViewInit {
  
  visaId:any;
  selectedIndex = -1;
  showSubGrp : boolean = false;
  @ViewChild('viewer') viewerRef:ElementRef;
  items:any = [];
  tabs:any;
  pdfTabs:any=[];
  pagesCount:any = [];
  formName: any = 'I-129';
  pageCountArray:any=[];
  totalPageCount:any;
  checkboxInput:any;
  selectAllInput:any;
  selectedAll:Boolean = false;
  placeHolderArray:any=[];
  selectedGroupId: number = 0;
  pdfURL:SafeResourceUrl;
  selectedPageNumbers:any;
  totalNumberofPages:any=[];
  fGroup:any={
    petitioner:{  

    }
  };
  envPath: any;
  isEditVisa:boolean = false;
 

  ngAfterViewInit(): void {
  
  }
   constructor(private toastr:ToastrService, private VDService:VisaDesignerService, private sanitizer: DomSanitizer, private encryptService: EncryptService){
  }

  ngOnInit(){
    this.envPath = environment;
    this.visaId = localStorage.getItem('visaId'); 
    this.visaId = this.encryptService.toEncrypt(this.visaId);
    this.VDService.formMappingPlaceholders(this.visaId).subscribe(res => {
      this.placeHolderArray = res.data.groups;
    });

    this.VDService.formMappingPagesCount(this.visaId).subscribe(res => {
      
     this.pdfTabs = res.data;
     for(var i=0; i<res.data.length; i++){
       if(res.data[i].id == 1){
        this.formTabClick(this.pdfTabs[i].noOfPages, this.pdfTabs[i].displayName,  this.pdfTabs[i].htmlLocation, res.data[i].id);
        this.formName = res.data[i].displayName;
        
        this.pdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(res.data[i].htmlLocation);
        this.totalPageCount = this.pdfTabs[i].noOfPages;
       }
     }
    });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
   }


   selectDropdownGroup(id){
    this.selectedGroupId = id;
   }

   toggleSubGrp(){
     this.showSubGrp = !this.showSubGrp;
   }

   hideSHowTopLevel(data){
     data = !data;
   }
   changeTabs(value){
      this.tabs = value;
   }

   formTabClick(value, name, url, formNumber){    
    var tempFormNumber = this.encryptService.toEncrypt(formNumber.toString());
    var formMappingGETURL = this.envPath.baseUrl+'/vd/taskType/' + this.visaId + '/form/' + tempFormNumber;
    var formMappingPOSTURL = this.envPath.baseUrl+'/vd/taskType/' + this.visaId + '/form/' + tempFormNumber + '/save';
 
    localStorage.setItem('formMappingGETURL', formMappingGETURL);
    localStorage.setItem('formMappingPOSTURL', formMappingPOSTURL);
     
    this.totalPageCount = value;
    this.formName = name;
    this.pdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);;
    this.pageCountArray=[];
    this.totalNumberofPages=[];

    this.pagesCount=[];
     for(var i=0; i<value; i++){
      this.pagesCount.push({'isSelected': false, 'pageNumber': i+1});
     }    

    
     this.VDService.formMappingFetchPageNumber(this.visaId, tempFormNumber).subscribe(res => {      
      this.pageCountArray = res.data.placeHolder.pageNumbers;
      for(var i=0; i< this.pageCountArray.length; i++){
        var x = this.pageCountArray[i];
        let getIndx = this.pagesCount.map(function(item){
          return item.pageNumber;
        }).indexOf(x);
        
        if(getIndx >= 0){
          this.pagesCount[getIndx].isSelected = true;
        }
              
      }
    });
     
   }

   copied(e, item) {
    this.toastr.info(`${item.fieldName + item.id} copied`);
  }
  selectAll(event){
    this.pageCountArray = [];

    if(event){      
      for(var i=0; i< this.pagesCount.length; i++){
          this.pageCountArray.push(i+1);
          this.pagesCount[i].isSelected = true;
      }
      localStorage.setItem("pageCounts", JSON.stringify(this.pageCountArray));
    }
    else{
      for(var i=0; i < this.pagesCount.length; i++){
        this.pagesCount[i].isSelected = false;
      } 
      this.pageCountArray = [];
      localStorage.setItem("pageCounts", JSON.stringify(this.pageCountArray));
    }
    
  }

  getPageNnmber(event, index){
    
    if(this.pagesCount[index].isSelected){
      if(this.pageCountArray.length == 0){
        this.pageCountArray.push(index+1); 
      }
      else{
        var getIndx = this.pageCountArray.map(function(item){
          return item;
        }).indexOf(index+1);
        if(getIndx == -1){
          this.pageCountArray.push(index+1);
        }
      }
    }
    else{
      var getIndx = this.pageCountArray.map(function(item){
        return item;
      }).indexOf(this.pagesCount[index].pageNumber);
      

      if(getIndx >= 0){
        this.pageCountArray.splice(getIndx, 1);
      }

      
    }
    
    console.log('pageArray', this.pageCountArray);
    localStorage.setItem("pageCounts", JSON.stringify(this.pageCountArray));
  }

}
